import { useCallback } from "react";
import { currencyFor, isOperatingCountry, type Currency } from "@nh/shared";
import { useAuth } from "@/features/auth/auth.context";
import { useConnectionCountry } from "./useConnectionCountry";

/**
 * La moneda en la que la tienda muestra —y cobra— los precios.
 *
 * ── La decide el PAÍS DE CONEXIÓN (Anahí, 14-sep-2026) ───────────────
 * «Que detecte en qué país se está conectando y en automático ponga el
 * precio: si está en Estados Unidos, dólares; si está en México, pesos.
 * El idioma sí se puede cambiar; la moneda no.»
 *
 * Antes (1-sep) la fijaba el país de la CUENTA y, sin sesión, se elegía
 * en la barra. Ahora nadie la elige: sale de dónde está quien mira
 * (`useConnectionCountry`: la IP por el servidor, la zona horaria del
 * aparato como respaldo). Si la conexión no es MX ni US, manda el país
 * de la cuenta; y si tampoco, la casa (pesos).
 *
 * Sigue siendo UNA moneda para pintar y cobrar: el checkout manda esta
 * misma, y con ella el servidor elige la cuenta de Stripe. Cambiar el
 * idioma no la toca — es la separación que pidió Anahí.
 *
 * `setCurrency` se conserva en la firma porque las pantallas la pasan a
 * `ShopLayout`, pero no hace nada: no hay mando que la cambie.
 */
export function useShopCurrency(): [Currency, (currency: Currency) => void] {
  const { user } = useAuth();
  const connection = useConnectionCountry();

  const country = connection ?? (isOperatingCountry(user?.country) ? user.country : null);
  const currency = currencyFor(country);

  const setCurrency = useCallback((_next: Currency) => {
    // La moneda la decide la conexión; desde la tienda no se toca.
  }, []);

  return [currency, setCurrency];
}

/**
 * La moneda está SIEMPRE decidida (14-sep). Se conserva para las
 * pantallas que preguntaban si esconder el selector: hoy no hay
 * selector, hay una etiqueta que dice en qué moneda están los precios.
 */
export function useCurrencyIsLocked(): boolean {
  return true;
}
